import {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {
    changeFormField, createFaq, initializeForm, initializeSaveResult,
    readFaqDetail, setFormFromDetail, updateFaq
} from '../../modules/admin/faq';
import {readCategoryList} from '../../modules/admin/docs';
import FaqEditor from '../../components/admin/faq/FaqEditor';

export default function FaqEditContainer({ mode }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const isEdit = mode === 'edit';

    const {
        form, categoryTree, detailResponse, saveResponse, saveErrorResponse, saving
    } = useSelector(({ faq, docs, loading }) => ({
        form: faq.form,
        categoryTree: docs.readCategoryListResponse,
        detailResponse: faq.detailResponse,
        saveResponse: faq.saveResponse,
        saveErrorResponse: faq.saveErrorResponse,
        saving: loading['faq/CREATE_FAQ'] || loading['faq/UPDATE_FAQ']
    }));

    useEffect(() => {
        dispatch(initializeForm());
        if (!categoryTree) {
            dispatch(readCategoryList());
        }
        if (isEdit && id) {
            dispatch(readFaqDetail({ id }));
        }
        return () => {
            dispatch(initializeSaveResult());
        };
    }, [dispatch, isEdit, id]);

    useEffect(() => {
        if (isEdit && detailResponse) {
            dispatch(setFormFromDetail(detailResponse));
        }
    }, [isEdit, detailResponse, dispatch]);

    useEffect(() => {
        if (saveResponse) {
            navigate('/admin/faq');
        }
    }, [saveResponse, navigate]);

    const handleChangeForm = ({ name, value }) => {
        dispatch(changeFormField({ name, value }));
    };

    const handleChangeCategory = ({ categoryMainId, categorySubId }) => {
        if (categoryMainId !== undefined) dispatch(changeFormField({ name: 'categoryMainId', value: categoryMainId }));
        if (categorySubId !== undefined) dispatch(changeFormField({ name: 'categorySubId', value: categorySubId }));
    };

    const handleSubmit = () => {
        const payload = { ...form };
        if (isEdit) {
            dispatch(updateFaq({ id, ...payload }));
        } else {
            dispatch(createFaq(payload));
        }
    };

    return (
        <FaqEditor
            mode={mode}
            form={form}
            detailResponse={detailResponse}
            categoryTree={categoryTree}
            saving={saving}
            saveErrorResponse={saveErrorResponse}
            onChangeForm={handleChangeForm}
            onChangeCategory={handleChangeCategory}
            onSubmit={handleSubmit}
        />
    );
}
